import React, { useState, useEffect, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Row } from 'primereact/row';
import { ColumnGroup } from 'primereact/columngroup';
import { Home_context } from '../../context/home_context';

// let Tolerance_dummy_data = [
//   {
//     Tests: 'Skin tolerance',
//     result: 'Support : Volunteers Amount : 20% ',
//     Conclusion: 'non irritant (skin)',
//   },
//   {
//     Tests: 'Ocular tolerance',
//     result: 'Support : Volunteers Amount : 20% ',
//     Conclusion: 'non irritant (eyes)',
//   },
//   {
//     Tests: 'Sensitization',
//     result: 'Support : Volunteers Amount : 20% ',
//     Conclusion: 'nonsensitizing',
//   },
// ];

// let Substantion_dummy_data = [
//   {
//     Tests: 'anti-aging',
//     data: 'Support : Volunteers',
//     Protocol:
//       'Granlipid RSC has been shown to stimulate the growth of epidermal cells comparable to the effects seen with retinyl palmitate. Epithelial cell cultures were grown in supplemented MEM. During exponential growth, media was supplemented with various concentration of ranlipid RSC or retinyl palmitate.',
//     result:
//       'At 0.1% retinyl palmitate increased epithelial growth rates by more than 80% while 0.05% Granlipid RSC increased rates by more than 140%. Using standard skin cell renewal assay (5% dansyl chloride in petrolatum) we observed that 0.5% Granlipid RSC in an inert vehicle ncreased skin cell renewal rate by 25%. This rate is the optimum amount one would like to see to deliver long-term skin anti-aging effects. ',
//   },
//   {
//     Tests: 'Skin elasticity',
//     data: 'Support : Volunteers Number : 10',
//     Protocol:
//       'Ten subjects with dry skin and showing the visible signs of aging, applied 2% Granlipid RSC twice a day for four weeks. At various times through the study test subjects were evaluated for a number of changes in skin condition',
//     result:
//       'Skin firmness evaluated by ballistometry, increased by 41% after 4 weeks of a treatment. A 17% increase was observed after only 2 weeks.    have biopsies were taken at the start and finish of the study. Sections of the stratum corneum were stained with oil red to highlight lipids and the results indicated an 86% increase in skin structural lipid content after the four weeks of treatment. We also observed that dryness on test subjects decreased by more than 30% after 4 weeks, and superficial lines and wrinkles were decreased by more than 25%. ',
//   },
// ];
export default function Tolerance_and_Substantion() {
  const { report_data_state } = useContext(Home_context);

  const Tolerance_headerGroup = (
    <ColumnGroup>
      {/* First row with TypeTest centered */}
      {/* <Row className="Tolerance_and_Substantion">
        <Column
          header="TypeTest"
          colSpan={3}
          style={{ textAlign: 'center', fontWeight: 'bold' }}
        />
      </Row> */}
      {/* Second row for subheaders */}
      <Row className="report_id_tables">
        <Column header="Tests" />
        <Column header="Result" />
        <Column header="Conclusion" />
      </Row>
      {/* Third row for a descriptive subtitle */}
      <Row>
        <Column
          header="Type of test : Clinical"
          colSpan={3}
          style={{ textAlign: 'center', fontStyle: 'italic' }}
        />
      </Row>
    </ColumnGroup>
  );

  const Substantion_headerGroup = (
    <ColumnGroup>
      {/* First row with TypeTest centered */}
      {/* <Row className="Tolerance_and_Substantion">
        <Column
          header="TypeTest"
          colSpan={4}
          style={{ textAlign: 'center', fontWeight: 'bold' }}
        />
      </Row> */}
      {/* Second row for subheaders */}
      <Row className="report_id_tables">
        <Column header="Tests" />
        <Column header="" />
        <Column header="Protocol" />
        <Column header="Result" />
      </Row>
      {/* Third row for a descriptive subtitle */}
      <Row>
        <Column
          header="Type of test : Clinical"
          colSpan={4}
          style={{ textAlign: 'center', fontStyle: 'italic' }}
        />
      </Row>
    </ColumnGroup>
  );

  return (
    <div>
      <div className=" card between_header_padding">
      <p className="page_headers  font-semibold text-start pt-2 header_color">
        TOLERANCE
      </p>
        <DataTable
          headerColumnGroup={Tolerance_headerGroup}
          value={report_data_state?.report_data['tolerance_dummy_data']}
          showGridlines
          className="page_table_font_size"
        >
          <Column field="Tests" header="Tests" />
          <Column field="result" header="Result" />
          <Column field="Conclusion" header="Conclusion" />
        </DataTable>
      </div>
      <div className="card">
        <p className="page_headers  font-semibold text-start pt-2 header_color">
           SUBSTANTIATION
        </p>
        <DataTable
          headerColumnGroup={Substantion_headerGroup}
          value={report_data_state?.report_data['Substantion_dummy_data']}
          showGridlines
          className="page_table_font_size"
        >
          <Column className="w-[20rem]" field="Tests" header="Tests" />
          <Column className="w-[20rem]" field="data" header="" />
          <Column field="Protocol" header="Protocol" />
          <Column field="result" header="Result" />
        </DataTable>
      </div>
    </div>
  );
}
